module.exports = __webpack_public_path__ + "static/img/certification.1c5d039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/certification.png
// module id = qNZ7
// module chunks = 1 3 4 5 6 7